import { GTM_EVENTS } from 'constants/gtm.js'

/**
 * Pushes an event to Google Tag Manager's dataLayer.
 *
 * @param {string} eventName - The name of the event to push. Must be one of the predefined GTM_EVENTS constants.
 * @param {Object} [eventData={}] - Additional data to be sent with the event.
 * @throws {void} - Logs error to console if eventName is invalid or eventData is not an object.
 *
 * @example
 * pushGTMEvent(GTM_EVENTS.USER_LOGIN, { userId: '123' });
 *
 * @description
 * This function validates the event name against predefined GTM_EVENTS,
 * ensures the eventData is an object, and pushes the event to GTM's dataLayer
 */
export const pushGTMEvent = (eventName, eventData = {}) => {
  // Verify if eventName is one of the values from GTM_EVENTS constant
  const validEventNames = Object.values(GTM_EVENTS)
  if (!validEventNames.includes(eventName)) {
    console.error(`GTM Event Error: eventName "${eventName}" is not a valid event name. Use one of the predefined GTM_EVENTS constants.`)
    return
  }

  // Ensure eventData is an object
  if (eventData && typeof eventData !== 'object') {
    console.error('GTM Event Error: eventData must be an object')
    return
  }

  // Create the complete event object by merging eventName and eventData
  const completeEventData = {
    event: eventName,
    ...eventData
  }

  // Check if dataLayer exists
  if (typeof window !== 'undefined' && window.dataLayer) {
    // Push the event to the dataLayer
    window.dataLayer.push(completeEventData)
  }
}
